import { Box } from '@mui/material';
import React from 'react';

const Timeline = ({ children }: { children: React.ReactNode }) => {
    const childrenArray = React.Children.toArray(children);
    return (
        <Box position="relative" display="flex" flexDirection="column" mr={2} minWidth="32px">
            {childrenArray.map((child, idx) => (
                <Box key={idx} position="relative">
                    {/* Vertical line for all except the last item */}
                    {idx !== childrenArray.length - 1 && (
                        <Box
                            position="absolute"
                            top={40}
                            bottom={0}
                            mt={1}
                            left="20px"
                            sx={{
                                width: '2px',
                                bgcolor: '#E2E8F0',
                                transform: 'translateX(-50%)',
                                zIndex: 0
                            }}
                        />
                    )}
                    {child}
                </Box>
            ))}
        </Box>
    );
};

export { Timeline };
